import AppCard, {
  ExtendedCloudApp,
  ExtendedGlobalApp,
} from "../../Cards/AppCard";
import SkeletonLoader from "../../../../elements/SkeletonLoader";
import AppEmptyState from "../../../../elements/AppEmptyState";
import { GlobalApp } from "../../../../types/GlobalInterfaces";

interface Props {
  allApps: GlobalApp[];
  mostPopularApps: ExtendedGlobalApp[];
  cloudApps: ExtendedCloudApp[];
  loading: boolean;
  openApp: (appID: string) => void;
}

const Section = ({
  title,
  apps,
  emptyStateTitle,
  emptyStateDescription,
  isGlobalApp = false,
  onAppClick,
}: {
  title: string;
  apps: (GlobalApp | ExtendedGlobalApp | ExtendedCloudApp)[];
  emptyStateTitle: string;
  emptyStateDescription: string;
  isGlobalApp?: boolean;
  onAppClick: (appID: string) => void;
}) => (
  <div className="tw:flex tw:flex-col tw:mb-10">
    <h3 className="tw:mx-2 tw:py-2 tw:mb-4 tw:text-black tw:border-b tw:border-superlight">
      {title}
    </h3>
    <div className="tw:flex tw:flex-wrap tw:justify-center tw:md:justify-start tw:gap-6">
      {apps.length > 0 ? (
        apps.map((app) => (
          <AppCard
            key={app.id}
            app={app}
            isGlobalApp={isGlobalApp}
            onClick={() => onAppClick(app.id)}
          />
        ))
      ) : (
        <div className="tw:w-full tw:px-2">
          <AppEmptyState
            title={emptyStateTitle}
            description={emptyStateDescription}
          />
        </div>
      )}
    </div>
  </div>
);

const AllProductsList = ({ allApps, cloudApps, loading, openApp }: Props) => {
  const handleClick = (app: any) => {
    openApp(typeof app === "string" ? app : app?._id);
  };

  return (
    <>
      <div className="tw:flex tw:flex-col tw:pb-3 tw:pt-5 tw:px-3 tw:w-full">
        {loading ? (
          <div className="tw:flex tw:flex-wrap tw:gap-6">
            {Array.from({ length: 8 }).map((_, index) => (
              <SkeletonLoader key={index} height={300} width={378} />
            ))}
          </div>
        ) : (
          <>
            {/* <Section
              title="Most Popular Apps"
              apps={mostPopularApps}
              emptyStateTitle="No Popular Apps Available"
              emptyStateDescription="There are no popular apps to install."
              onAppClick={handleClick}
            /> */}
            <Section
              title="Global Apps"
              apps={allApps}
              emptyStateTitle="No Global Apps Available"
              emptyStateDescription="There are no global apps installed."
              onAppClick={handleClick}
              isGlobalApp
            />
            <Section
              title="Local Apps"
              apps={cloudApps}
              emptyStateTitle="No Local Apps Available"
              emptyStateDescription="There are no local apps."
              onAppClick={handleClick}
            />
          </>
        )}
      </div>
    </>
  );
};

export default AllProductsList;
